// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__5PPO_","modalFooterButton":"ModalNotes_modalFooterButton__llaNE"};